/**
 * 微信小程序「艾斯达星选」跳转工具（URL Link 方案）
 *
 * URL Link 是微信官方提供的从网页打开小程序的方式，形如 https://wxaurl.cn/xxxxxx，
 * 在微信内点击可直接拉起小程序指定页面，在微信外点击会引导打开微信。
 * 不需要 wx.config 签名，但需要一个能调用微信 generate_urllink 接口的服务端。
 *
 * 配置说明（请在下方填写真实值）：
 *  - URL_LINK_API：服务端生成 URL Link 的接口地址，接收 path 与 query 参数，返回 { url: "..." }
 *  - DEFAULT_URL_LINK：未配置接口时的兜底链接，通常是小程序首页的 URL Link（可在小程序后台手动生成）
 *  - DETAIL_PAGE_PATH：小程序商品详情页路径
 *  - DETAIL_QUERY_KEY：详情页接收商品 ID 的查询参数名
 */

/* ====== 配置项（请替换为真实值） ====== */
/* 小程序原始 ID（gh_ 开头），用于 wx-open-launch-weapp 方案（需配合 wx.config 签名） */
export const MINI_PROGRAM_USERNAME = "gh_853960745515";
/* URL Link 方案：服务端生成 URL Link 的接口地址，接收 path 与 query 参数，返回 { url: "..." } */
export const URL_LINK_API = "/api/wx/urllink";
/* 未配置接口时的兜底链接，通常是小程序首页的 URL Link（可在小程序后台手动生成） */
export const DEFAULT_URL_LINK = ""; // 例："https://wxaurl.cn/xxxxxxxx"
export const DETAIL_PAGE_PATH = "pages/market/marketIndex";
export const DETAIL_QUERY_KEY = "";
/* ====================================== */

var urlLinkCache = {};
var CACHE_PREFIX = "asstar_urllink_";

/* 从 localStorage 读取缓存 */
function readCache() {
  try {
    var raw = localStorage.getItem(CACHE_PREFIX + "map");
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
}

/* 写入缓存 */
function writeCache(map) {
  try {
    localStorage.setItem(CACHE_PREFIX + "map", JSON.stringify(map));
  } catch (e) {}
}

urlLinkCache = readCache();

/**
 * 获取商品对应的小程序 URL Link
 * @param {Object} product 商品对象，需包含能唯一标识商品的字段（优先 ID，其次 name）
 * @returns {Promise<string>} URL Link
 */
export function getProductUrlLink(product) {
  var id = (product && (product.ID || product.id)) || "";
  var cacheKey = id || (product && product.name) || "home";

  /* 命中缓存直接返回 */
  if (urlLinkCache[cacheKey]) {
    return Promise.resolve(urlLinkCache[cacheKey]);
  }

  /* 未配置生成接口 → 使用兜底首页链接 */
  if (!URL_LINK_API) {
    if (DEFAULT_URL_LINK) return Promise.resolve(DEFAULT_URL_LINK);
    return Promise.reject(new Error("未配置 URL_LINK_API 与 DEFAULT_URL_LINK"));
  }

  var query = (id && DETAIL_QUERY_KEY) ? DETAIL_QUERY_KEY + "=" + encodeURIComponent(id) : "";
  var url = URL_LINK_API +
    (URL_LINK_API.indexOf("?") > -1 ? "&" : "?") +
    "path=" + encodeURIComponent(DETAIL_PAGE_PATH) +
    (query ? "&query=" + encodeURIComponent(query) : "");

  return fetch(url)
    .then(function (res) { return res.json(); })
    .then(function (data) {
      var link = (data && (data.url || data.UrlLink || data.data)) || "";
      if (typeof link !== "string" || !link) {
        throw new Error("URL Link 接口返回无效");
      }
      urlLinkCache[cacheKey] = link;
      writeCache(urlLinkCache);
      return link;
    })
    .catch(function () {
      /* 接口失败时回退到首页链接 */
      if (DEFAULT_URL_LINK) return DEFAULT_URL_LINK;
      throw new Error("获取小程序链接失败");
    });
}

/**
 * 点击商品 → 拉起微信小程序商品详情页
 * @param {Object} product 商品对象
 */
export function launchMiniProgram(product) {
  getProductUrlLink(product)
    .then(function (link) {
      window.location.href = link;
    })
    .catch(function (e) {
      console.warn("跳转小程序失败：", e.message);
      alert("请在微信中打开本页面，或搜索小程序「艾斯达星选」");
    });
}
